import { Component, OnInit } from '@angular/core';
import { isNullOrUndefined } from 'util';
import { TownHallsService } from "../../service/main/town-halls.service";
import { ToastrService } from '../../service/common/toastr.service';

@Component({
  selector: 'app-town-halls-police',
  templateUrl: './town-halls-police.component.html',
  styleUrls: ['./town-halls-police.component.css']
})
export class TownHallsPoliceComponent implements OnInit {

  townHall: any = null;
  isEditable: boolean = false;

  constructor(
    private publicInstitution: TownHallsService,
    private toastr: ToastrService,
  ) {
  }

  ngOnInit() {
    this.publicInstitution.getPublicInstitutions().subscribe(res => {
      if (res) {
        this.townHall = {
          id: res.publicInstitutionID,
          contactID: res.contactPersonID,
          title: res.title,
          bankAccount: res.bankAccount,
          address: res.address,
          contactName: res.contactName,
          contactPhone: res.contactPhone,
          contactEmail: res.contactEmail,
          location: res.location,
          caleUser: res.user,
          calePassword: res.password,
          totalIncome: res.totalIncome,
          parkings: res.parkings.length
        }
      }
    });
  }

  addtownhallpolice() {

  }
  showEditable() {
    this.isEditable = !this.isEditable;
  }
  saveEditInfo(formValues) {
    let editInfo = {
      publicInstitutionID: this.townHall.id,
      contactPersonID: this.townHall.contactID,
      title: formValues.title,
      bankAccount: formValues.bankAccount,
      address: formValues.address,
      location: formValues.location,
      contactName: formValues.contactName,
      contactPhone: formValues.contactPhone,
      contactEmail: formValues.contactEmail,
    }
    this.publicInstitution.editPublicInstitution(editInfo).subscribe(res => {
      if (res) {
        this.isEditable = !this.isEditable;
        this.toastr.success('Institution was successfully edited.');
      }
    }, err => {
      this.toastr.error('An error has occurred while editing the institution.');
    });
  }
}
